import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest, isEmptyObject } from '../../../../utils';

const CardDetails = (props) => {
    const { data, isStudent, setState, onError, onClose } = props;
    const [loading, setLoading] = useState(false);
    const [cardInformation, setCardInformation] = useState(data);

    const onSubmit = async (id, updatedInformation) => {
        const { data, success } = await AuthenticatedPUTRequest(
            isStudent ? `students/${id}` : `applicants/${id}`,
            updatedInformation,
        );
        setLoading(false);
        onClose();
        if (!success) {
            onError('براہ کرم دوبارہ کوشش کریں۔');
        } else {
            setState(data);
        }
    };

    const onUpdate = () => {
        setLoading(true);
        var updatedInformation = {};
        for (let key in cardInformation) {
            if (key !== 'branch' && key !== 'class_room') {
                if (cardInformation[key] !== data[key]) {
                    updatedInformation[key] = cardInformation[key];
                }
            }
        }
        if (!isEmptyObject(updatedInformation)) {
            onSubmit(cardInformation.id, updatedInformation);
        } else {
            setLoading(false);
            onClose();
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 480,
                    maxHeight: 480,
                    width: 980,
                    borderRadius: 8,
                }}
            >
                <div
                    className='h-100 w-100'
                    style={{ overflow: 'auto', position: 'relative', direction: 'ltr' }}
                >
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            کارڈ سے متعلق معلومات ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20 }}
                    >
                        <div className='flex column w-100'>
                            <div className='flex justifyBetween alignCenter'>
                                {/* name */}
                                <div className='form-container english'>
                                    <label htmlFor='name'>
                                        
                                        Applicant name
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='name'
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        value={cardInformation['name_for_card']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setCardInformation({
                                                    ...cardInformation,
                                                    name_for_card: e.target.value,
                                                });
                                            } else {
                                                setCardInformation({
                                                    ...cardInformation,
                                                    name_for_card: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div
                                className='flex justifyBetween alignCenter'
                                style={{ marginTop: 16 }}
                            >
                                <div className='form-container english'>
                                    <label htmlFor='address_for_card'>
                                        Complete address
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='address_for_card'
                                        className='flex alignStart justifyStart'
                                        style={{
                                            height: 120,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        value={cardInformation['address_for_card']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setCardInformation({
                                                    ...cardInformation,
                                                    address_for_card: e.target.value,
                                                });
                                            } else {
                                                setCardInformation({
                                                    ...cardInformation,
                                                    address_for_card: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className='flex justifyEnd alignCenter w-100'
                            style={{ height: 64, marginTop: 16 }}
                        >
                            <div className='flex justifyBetween alignCenter'>
                                <div
                                    className='flex justifyEnd alignCenter register_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onUpdate()}
                                >
                                    {loading ? (
                                        <div className='custom_loader' />
                                    ) : (
                                        <h3>{`محفوظ کریں`}</h3>
                                    )}
                                </div>
                                <div
                                    className='flex justifyEnd alignCenter delete_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onClose()}
                                >
                                    <h3>{`منسوخ کریں`}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardDetails;
